import React, { useEffect, useState } from "react";
import { Button, TextField, CircularProgress } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import MasterViewController from "../../redux/actions/masterApiActions";
import FormDrawer from "../../components/layout/FormDrawer";
import { primaryButtonSx, inputSx } from "../../components/auth/authTheme";

import "../../styles/styles.css";
import "../../styles/layout.css";

const validationSchema = Yup.object({
  name: Yup.string().trim().required("Designation name is required"),
});

function DesignationFormModal({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const { addDesignation, updateDesignation } = MasterViewController();
  const { isLoding } = useSelector((state) => state.master);

  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({ name: "" });

  useEffect(() => {
    if (!show) return;
    setInitialValues({
      name: initialData?.name || "",
    });
  }, [show, initialData?.id, initialData?.name]);

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      const action = isEdit
        ? updateDesignation(initialData.id, values)
        : addDesignation(values);
      await dispatch(action);
      resetForm();
      handleClose();
    } catch (error) {
      console.error("Error submitting designation form:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      validateOnBlur
      validateOnChange={false}
      onSubmit={handleSubmit}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        submitForm,
        handleChange,
        handleBlur,
      }) => {
        const isSaving = isSubmitting || isLoding;

        return (
          <Form style={{ display: "contents" }}>
            <FormDrawer
              open={show}
              onClose={handleClose}
              title={isEdit ? "Edit Designation" : "Add Designation"}
              subtitle={
                isEdit
                  ? "Update designation details"
                  : "Create a new job title for your organization"
              }
              footer={
                <>
                  <Button onClick={handleClose} color="inherit" disabled={isSaving}>
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    disabled={isSaving}
                    onClick={() => submitForm()}
                    sx={{
                      ...primaryButtonSx,
                      minWidth: 120,
                      "&.Mui-disabled": {
                        bgcolor: isSaving ? "#FF6A00" : undefined,
                        color: isSaving ? "#fff" : undefined,
                        opacity: isSaving ? 0.85 : undefined,
                      },
                    }}
                    startIcon={
                      isSaving ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : null
                    }
                  >
                    {isSaving
                      ? isEdit
                        ? "Updating..."
                        : "Creating..."
                      : isEdit
                        ? "Update"
                        : "Create"}
                  </Button>
                </>
              }
            >
              <TextField
                label="Designation Name"
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
                required
                placeholder="e.g. Software Engineer"
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                sx={inputSx}
              />
            </FormDrawer>
          </Form>
        );
      }}
    </Formik>
  );
}

export default DesignationFormModal;
